module.exports = __webpack_public_path__ + "img/scroll5.3abdb233.png";